<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [style]="{width: '65vw', height: '600px'}"
  styleClass="p-fluid p-dialog-intervento-nuovo"
  [showHeader]="true"
  header="Nuovo Intervento"
  (onHide)="hide()">

  <ng-template pTemplate="header">
    <div class="header-content">
      <span class="material-icons" style="vertical-align: middle; margin-right: 8px; font-size: 28px;">construction</span>
      <span>Aggiungi intervento in variante</span>
    </div>
  </ng-template>

  <div class="dialog-container">
    <!-- Steps -->
    <p-steps [model]="items" [activeIndex]="activeIndex" [readonly]="false" [style]="{'margin-top': '1rem'}"></p-steps>

    <!-- Contenuto principale -->
    <form [formGroup]="form" class="dialog-content" *ngIf="form">
      <!-- Step 1: Selezione Scheda -->
      <div *ngIf="activeIndex === 0" class="step-content">
        <div class="form-group">
          <label for="scheda">Scegli la Scheda</label>
          <p-dropdown
            id="scheda"
            [options]="schede"
            optionLabel="codice"
            formControlName="scheda"
            [showClear]="true"
            placeholder="Seleziona la scheda"
            [filter]="true"
            filterBy="codice,vecchioCodiceUmvs"
            [style]="{'width': '100%'}"
            [styleClass]="'text-left'"
            [appendTo]="'body'"
            [loading]="loadingSchede">
          <ng-template pTemplate="item" let-scheda>
            <div class="scheda-item" style="display: flex; align-items: center; gap: 0.5rem; white-space: nowrap;">
              <div class="code-badge" style="display: inline-flex; align-items: center; background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px;">
                <span style="font-size: 0.8rem; color: #666; margin-right: 0.25rem;">NUOVO CODICE:</span>
                <span class="codice-scheda-badge" style="font-weight: bold; color: #3a6e75;">{{ scheda.codice | uppercase }}</span>
              </div>
              <div class="code-badge" style="display: inline-flex; align-items: center; background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px;">
                <span style="font-size: 0.8rem; color: #666; margin-right: 0.25rem;">VECCHIO CODICE:</span>
                <span class="vecchio-codice-umvs-badge" style="font-weight: bold; color: #666;">{{ scheda.vecchioCodiceUmvs | uppercase }}</span>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="selectedItem" let-scheda>
            <div class="scheda-item" style="display: flex; align-items: center; gap: 0.5rem; white-space: nowrap;">
              <div class="code-badge" style="display: inline-flex; align-items: center; background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px;">
               <!--  <span style="font-size: 0.8rem; color: #666; margin-right: 0.25rem;">NUOVO:</span> -->
                <span class="codice-scheda-badge" style="font-weight: bold; color: #3a6e75;">{{ scheda.codice | uppercase }}</span>
              </div>
              <div class="code-badge" style="display: inline-flex; align-items: center; background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px;">
                <!-- <span style="font-size: 0.8rem; color: #666; margin-right: 0.25rem;">VECCHIO:</span> -->
                <span class="vecchio-codice-umvs-badge" style="font-weight: bold; color: #666;">{{ scheda.vecchioCodiceUmvs | uppercase }}</span>
              </div>
            </div>
          </ng-template>
        </p-dropdown>
        </div>
      </div>

      <!-- Step 2: Dettagli Intervento -->
      <div *ngIf="activeIndex === 1" class="step-content">
        <div class="form-group" style="display: flex; gap: 1rem; align-items: flex-start; flex-direction: row;">
          <div style="flex: 1; display: inline-block;">
            <label for="tipoIntervento" style="margin-bottom: 0.5rem; display: block;">Tipo Intervento</label>
            <p-dropdown
              id="tipoIntervento"
              [options]="tipiIntervento"
              optionLabel="descrizione"
              formControlName="tipoIntervento"
              [showClear]="true"
              placeholder="Seleziona il tipo di intervento"
              [style]="{'width': '100%'}"
              [styleClass]="'text-left'">
              <ng-template pTemplate="item" let-tipoIntervento>
                <div [ngStyle]="stiliService.getStileTipoInterventoDropdown(tipoIntervento.id)">
                  <i class="material-icons tipo-intervento-badge-icon">
                    {{ stiliService.getIconaTipoIntervento(tipoIntervento.id) }}
                  </i>
                  <span class="tipo-intervento-badge-value">{{ tipoIntervento.descrizione | uppercase }}</span>
                </div>
              </ng-template>
              <ng-template pTemplate="selectedItem" let-tipoIntervento>
                <div [ngStyle]="stiliService.getStileTipoInterventoDropdown(tipoIntervento.id)" pTooltip="{{ tipoIntervento.descrizione }}" tooltipPosition="top">
                  <i class="material-icons tipo-intervento-badge-icon">
                    {{ stiliService.getIconaTipoIntervento(tipoIntervento.id) }}
                  </i>
                  <span class="tipo-intervento-badge-value">{{ tipoIntervento.descrizione | uppercase }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>

          <div style="flex: 0.6; display: inline-block;">
            <label for="priorita" style="margin-bottom: 0.5rem; display: block;">Priorità</label>
            <p-dropdown
              id="priorita"
              [options]="priorita"
              optionLabel="label"
              formControlName="priorita"
              [showClear]="true"
              placeholder="Seleziona la priorità"
              [style]="{'width': '100%'}"
              [styleClass]="'text-left'">
              <ng-template pTemplate="item" let-priorita>
                <div [ngStyle]="stiliService.getStilePrioritaInterventoInForm(priorita.value)" style="text-align: left">
                  <i class="material-icons" style="font-size: 18px; margin-right: 4px;">
                    {{ stiliService.getIconaPrioritaIntervento(priorita.value) }}
                  </i>
                  <span class="ml-2">{{ priorita.label | uppercase }}</span>
                </div>
              </ng-template>
              <ng-template pTemplate="selectedItem" let-priorita>
                <div [ngStyle]="stiliService.getStilePrioritaInterventoInForm(priorita.value)" style="text-align: left">
                 <!--  <i class="material-icons" style="font-size: 18px; margin-right: 4px;">
                    {{ stiliService.getIconaPrioritaIntervento(priorita.value) }}
                  </i> -->
                  <span class="ml-2">{{ priorita.label | uppercase }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>

          <div style="flex: 0.8; display: inline-block;">
            <label for="importoFinanziato" style="margin-bottom: 0.5rem; display: block;">Importo Finanziato</label>
            <p-inputNumber
              id="importoFinanziato"
              formControlName="importoFinanziato"
              mode="currency"
              currency="EUR"
              locale="it-IT"
              placeholder="0"
              [style]="{'width': '100%'}"
              [styleClass]="'text-right'"
              [inputStyle]="{'text-align': 'right'}">
            </p-inputNumber>
          </div>
        </div>

        <div class="form-group">
          <label for="note">Note</label>
          <textarea
            id="note"
            pInputTextarea
            formControlName="note"
            [rows]="3"
            placeholder="Inserisci eventuali note"
            style="width: 100%">
          </textarea>
        </div>
      </div>
    </form>
  </div>

  <!-- Footer del dialog -->
  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-text"
        (click)="hide()">
      </button>
      <button
        pButton
        pRipple
        label="Indietro"
        icon="pi pi-arrow-left"
        class="p-button-text"
        *ngIf="activeIndex > 0"
        (click)="prevStep()">
      </button>
      <button
        pButton
        pRipple
        label="Avanti"
        icon="pi pi-arrow-right"
        class="p-button-primary"
        *ngIf="activeIndex < items.length - 1"
        (click)="nextStep()"
        [disabled]="form.invalid || loadingSchede">
      </button>
      <button
        pButton
        pRipple
        label="Aggiungi"
        icon="pi pi-check"
        class="p-button-success"
        *ngIf="activeIndex === items.length - 1"
        [loading]="submitting"
        (click)="aggiungiIntervento()">
      </button>
    </div>
  </ng-template>
</p-dialog>

<!-- Toast per notifiche -->
<p-toast position="top-right"></p-toast>
